import { OrderItem } from "../entity/shared/OrderItem";

export interface SplitOrderItems {
	orderId: number,
	originalItems: OrderItem[],
	splitItems: OrderItem[]
}